import { render } from "./NavInternalItem.vue?vue&type=template&id=03aa1747"
import script from "./NavInternalItem.vue?vue&type=script&lang=js"
export * from "./NavInternalItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__